import { useMemo as t } from "react";
const u = (e, n) => {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}, s = (...e) => t(() => e.every((n) => n === null) ? null : (n) => {
  for (const o of e)
    u(o, n);
}, [e]);
export {
  s as u
};
//# sourceMappingURL=use-merge-refs-DEJnLwh4.js.map
